import apiClient from 'apiClient';
import { Investment as API } from './Investment';
import { Endowment as Domain } from 'modules/cm/RepaymentStrategy/Endowment';
import { apiToDomain } from './mapper';

const create = async (apiPrefix: string): Promise<Domain> => {
  const { data } = await apiClient.post<API>(`${apiPrefix}`);
  return apiToDomain(data);
};

export default create;
